import * as React from "react";
import { BaseLayout } from "../../shared/components/BaseLayout";
import { useApiModels } from "../../shared/hooks/useApiModels";
import { NotificationsApi } from "../../client";
import { Input, Space, Typography } from "antd";
import { NotificationTable } from "../components/NotificationTable";

interface IProps {}

export const NotificationOverview: React.FC<IProps> = (props) => {
    const [searchValue, setSearchValue] = React.useState("");

    const baseFilters = {
        all: searchValue,
    };

    const {
        models: notifications,
        loading,
        fetch,
        tableProps,
    } = useApiModels(
        (page, filters) =>
            new NotificationsApi().listNotifications({
                page,
                ...baseFilters,
                ...filters,
            }),
        "notifications"
    );

    return (
        <BaseLayout>
            <Typography.Title level={3}>Notifications</Typography.Title>

            <div style={{ margin: "1em auto", display: "flex" }}>
                <Space>
                    <Input.Search
                        placeholder="search..."
                        loading={loading}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onSearch={() => fetch()}
                    />
                </Space>
            </div>

            <NotificationTable
                notifications={notifications}
                loading={loading}
                tableProps={tableProps}
            />
        </BaseLayout>
    );
};
